
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".5","d":"M11.863 10.654H9.106l-.76 2.009-1.92-.735 3.216-8.492 1.707-.002 3.14 8.37h6.404V0H.116v17.774h3.142v3.675l4.885-3.675h4.256v-5.691l-.536-1.43z","fill":"#fff"}}),_c('path',{attrs:{"opacity":".5","d":"M9.888 8.588h1.2l-.597-1.592-.603 1.592z","fill":"#fff"}}),_c('path',{attrs:{"d":"M24.42 25.265c.351 0 .686-.071.992-.2l-1.115-1.122 1.452-1.46 1.09 1.097a2.597 2.597 0 00-2.42-3.517 2.596 2.596 0 00-2.585 2.601 2.596 2.596 0 002.585 2.601z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.384 13.801v17.774h12.75l4.885 3.675v-3.675h3.142V13.801H14.384zm10.035 4.196c2.558 0 4.64 2.094 4.64 4.667 0 .899-.255 1.738-.694 2.45l1.4 1.41-1.451 1.46-1.389-1.396a4.591 4.591 0 01-2.506.742c-2.558 0-4.64-2.093-4.64-4.666 0-2.573 2.082-4.667 4.64-4.667z","fill":"#fff"}})])
          )
        }
      }
    